import React from 'react';
import './common.scss';
import { Hidden } from '@material-ui/core';

function BottomButton(props) {

  return (
    <Hidden mdUp>
      <div className="button-container">
        <button
          type={props.type}
          className={`button ${props.green ? 'green-bg' : ''}`}
          onClick={props.handleClick}
          disabled={props.disabled}
        >
          {props.title}
        </button>
      </div>
    </Hidden>
  );
}

BottomButton.defaultProps = {
  type: 'button'
};

export default BottomButton;
